import { DelFileWorkFlow, CopyFileWorkFlow, GetFileWorkFlow, GetProUsersList, AddFileWorkFlow, FindFileWorkFlow, UpdateFileWorkFlow } from '@/setAxios'
export default {
    data() {
        return {
            type: 'add',
            addActionFlowVisible: false,
            userList: [],
            examineType: [
                { value: 0, label: "会签" },
                { value: 1, label: "或签" }
            ],
            model: {
                model: {
                    pfwf01: "",
                    pfwf02: localStorage.xid,
                    pfwf03: "",
                    pfwf04: localStorage.id,
                    pfwf05: 0,
                    pfwf06: new Date(),
                },
                list: [{
                    name: "",
                    users: [],
                    type: 0,
                },],
            },
            tableData: [],
            loading: false,
            globalType: 0,
            multipleSelection: []
        }
    },
    methods: {
        async DelFileWorkFlow(type, data) {
            let ids = [];
            if (type == 'single') {
                ids = [data.pfwf01]
            } else {
                this.multipleSelection.forEach(ele => {
                    ids.push(ele.pfwf01)
                })
            }
            let res = await DelFileWorkFlow({ ids })
            if (res.Code) {
                this.$message({
                    type: 'success',
                    message: "删除成功"
                })
            }
            this.GetFileWorkFlow()
        },
        removetag(data) {
            let findId = this.userList.findIndex((ele) => ele.user01 == data);
            this.userList[findId].isSelect = false;
        },
        changeUser(data) {
            data.forEach(ele => {
                let findId = this.userList.findIndex((ele2) => ele2.user01 == ele);
                this.$set(this.userList[findId], "isSelect", true);
            })
        },
        addFlowDom(scope) {
            if (scope) {
                this.model.list.splice(scope.$index + 1, 0, {
                    name: "",
                    users: [],
                    type: 0,
                })
            } else {
                this.model.list.push({
                    name: "",
                    users: [],
                    type: 0,
                })
            }
        },
        deleteFlowDom(scope) {
            this.model.list.splice(scope.$index, 1);
            this.userList.forEach(ele => {
                if (scope.row.users.includes(ele.user01)) {
                    ele.isSelect = false;
                }
            })
        },
        async AddFileWorkFlow() {
            if(this.model.model.pfwf03==""){
                this.$message.error("请填写审核名称");
                return;
            }
            if (this.model.list.some(w => w.name == null || w.name == "")) {
                this.$message.error("请填写流程节点");
                return;
            }
            if (this.model.list.some(w => w.users == null || w.users == ""||w.users.length==0)) {
                this.$message.error("请选择审核人员");
                return;
            }
            this.model.list.forEach(ele => {
                ele.users = ele.users.join(',')
            })
           
            let res = [];
            if (this.type == 'add') {
                res = await AddFileWorkFlow({ model: this.model })
            } else {
                if (this.modelListJSON !== JSON.stringify(this.model.list)) {
                    this.model.isNeedUpdate = true;
                }
                res = await UpdateFileWorkFlow({ model: this.model })
            }
            if (res.Code) {
                this.$message({
                    type: "success",
                    message: this.type == 'add' ? "添加成功" : '修改成功'
                })
                this.addActionFlowVisible = false;
                this.model = {
                    model: {
                        pfwf01: "",
                        pfwf02: localStorage.xid,
                        pfwf03: "",
                        pfwf04: localStorage.id,
                        pfwf05: 0,
                        pfwf06: new Date(),
                    },
                    list: [{
                        name: "",
                        users: [],
                        type: 0,
                    },],
                }
                this.GetFileWorkFlow()
            }
        },
        async addActionFlow() {
            this.addActionFlowVisible = true;
            this.type = "add"
            let params = {
                seachword: "",
                id: localStorage.xid,
                cid: localStorage.pid,
                bid: "null",
                pageIndex: 1,
                pageSize: 10000
            }
            let res = await GetProUsersList({ params })
            this.userList = res.Data.list;
            this.userList.forEach((ele) => {
                ele.isSelect = false;
            });
        },
        async updateFlow(data) {
            this.addActionFlowVisible = true;
            this.type = 'update'
            var params = {
                seachword: "",
                id: localStorage.xid,
                cid: localStorage.pid,
                bid: "null",
                pageIndex: 1,
                pageSize: 10000
            }
            var res = await GetProUsersList({ params })
            this.userList = res.Data.list;
            var params = { id: data.pfwf01 }
            var res = await FindFileWorkFlow({ params })
            this.model = res.Data;
            this.modelListJSON = JSON.stringify(res.Data.list);
            let userList = [];
            this.model.list.forEach(ele => {
                ele.users = ele.users.split(',').map(Number)
                userList = userList.concat(ele.users)
            })
            this.userList.forEach(ele => {
                if (userList.includes(ele.user01)) {
                    ele.isSelect = true;
                } else {
                    ele.isSelect = false;
                }
            })
        },
        async GetFileWorkFlow() {
            this.loading = true;
            let params = {
                xid: localStorage.xid,
                uid: localStorage.id,
                type: this.globalType,
            };
            let res = await GetFileWorkFlow({ params });
            this.tableData = res.Data;
            this.loading = false;
        },
        async CopyFileWorkFlow(data) {
            let res = await CopyFileWorkFlow({ id: data.pfwf01 })
            if (res.Code) {
                this.$message({
                    type: 'success',
                    message: '复制成功'
                })
                this.GetFileWorkFlow()
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    }
}